<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Ladestation Inbetriebnahme Assistent</h5>
    <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="onCancelClick()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
      <div class="container-fluid">
        <div *ngIf="showStep1">
          <div class="row">
            <div class="d-none d-lg-inline col-lg-4">
              <div class="border-2 bg-light rounded-1 p-2 shadow-sm mb-2">
                <h5>Schritt 1</h5>
                <h6>Erstellen von GUID und Passwort</h6>
              </div>
              <div class="border-1 rounded-1 p-2 shadow-sm mb-2">
                <h5>Schritt 2</h5>
                <h6>Standortdaten eingeben</h6>
              </div>
              <div class="border-1 rounded-1 p-2 shadow-sm">
                <h5>Schritt 3</h5>
                <h6>Zusammenfassung</h6>
              </div>
            </div>
            <div class="col-12 col-lg-8">
              <h5>Vorbereitung:</h5>
              <p class="small">Damit die Ladestation mit unserer Anwendung kommunizieren kann, müssen folgende Werte in
                die Ladestation eingetragen werden:</p>
              <button class="btn btn-success d-none" (click)="generateCredentials()">Erstellen</button>
              <div class="mt-3">
                <div class="input-group">
                  <span class="input-group-text" style="width:115px;">Backend-URL:</span>
                  <input type="text" aria-label="wssurl" class="form-control" readonly
                    value="wss://ocpp-dev.mycubos.com/api/ocpp">
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                    (click)="copyToClipboard(wssurl, 'Backend-URL')"><app-svg source="icons/feather/copy"
                      height="18"></app-svg></button>
                </div>
              </div>
              <div class="mt-3">
                <div class="input-group">
                  <span class="input-group-text" style="width:115px;">Identität:</span>
                  <input type="text" aria-label="guid" class="form-control" value="{{ guid }}">
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                    (click)="copyToClipboard(guid, 'Identität')"><app-svg source="icons/feather/copy"
                      height="18"></app-svg></button>
                </div>
                <p class="small text-muted">Die Identität ist nicht zwingend der Name der Ladestation. Dieser kann im
                  weiteren Verlauf dieses Assistenten einzeln vergeben werden.</p>
              </div>
              <strong>Passwort generieren</strong>
              <hr class="m-0 p-0" />
              <div class="form-row row mt-2 mb-2">
                <div class="col-sm-3">
                  <label for="length">Länge:</label>
                  <input type="number" name="length" class="form-control" (change)="pwlength($event)" min="8" max="40"
                    value="12">
                </div>
                <div class="col align-content-end" style="display:inline;vertical-align: middle;padding-bottom:0.4rem;">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="numbers" value="1"
                      (change)="hasNum($event)" checked>
                    <label class="form-check-label" for="numbers">mit Zahlen</label>
                  </div>
                </div>
                <div class="col align-content-end" style="display:inline;vertical-align: middle;padding-bottom:0.4rem;">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="symbols" value="1"
                      (change)="hasSym($event)">
                    <label class="form-check-label" for="symbols">mit Sonderzeichen</label>
                  </div>
                </div>
              </div>
              <div class="input-group mb-3">
                <button class="btn btn-outline-secondary" type="button" id="btnGeneratePwd"
                  (click)="generatePassword()">Generieren</button>
                <input type="text" class="form-control" id="key" name="key" formControlName="key" placeholder=""
                  aria-label="Generated password" aria-describedby="btnGeneratePwd">
                <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="copyToClipboard(password, 'Passwort')"><app-svg source="icons/feather/copy"
                    height="18"></app-svg></button>

              </div>
              <!--<div class="mt-3">
              <div class="input-group">
                <span class="input-group-text" style="width:115px;">Kennwort:</span>
                <input type="text" aria-label="password" class="form-control" value="{{ password }}">
                <button class="btn btn-sm btn-outline-secondary" (click)="copyToClipboard(password, 'Kennwort')"><app-svg source="icons/feather/copy" height="18"></app-svg></button>
              </div>
            </div>-->
              <div class="mt-3">
                <p class="small">Bitte tragen Sie die oben stehenden Werte an den entsprechenden Stellen in Ihrem
                  Backend der Ladestation ein. Ggf. ist ein Neustart der Ladestation notwendig, damit die neuen
                  Einstellungen aktiviert werden. </p>
              </div>
              <div class="row mt-3 mb-3">
                <div class="col-4">
                  <button type="button" class="btn btn-primary" [disabled]="confirmCopyBtnDisabled"
                    (click)="waitForStation()">Weiter</button>
                </div>
                <div class="col-8 text-center">
                  <div id="waitForStationSpinner" class="d-none">
                    <span class="spinner-border spinner-border-sm" role="status"></span>
                    Warten auf Antwort der Ladestation
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showStep2">
          <div class="row">
            <div class="d-none d-lg-inline col-lg-4">
              <div class="border-1 rounded-1 p-2 shadow-sm mb-2">
                <h5>Schritt 1</h5>
                <h6>Erstellen von GUID und Passwort</h6>
              </div>
              <div class="border-2 bg-light rounded-1 p-2 shadow-sm mb-2">
                <h5>Schritt 2</h5>
                <h6>Standortdaten eingeben</h6>
              </div>
              <div class="border-1 rounded-1 p-2 shadow-sm">
                <h5>Schritt 3</h5>
                <h6>Zusammenfassung</h6>
              </div>
            </div>
            <div class="col-12 col-lg-8">
              <div class="mb-3">
                <label for="street" class="form-label">Straße</label>
                <input type="text" id="street" formControlName="street" class="form-control" placeholder="Straße">
              </div>
              <div class="mb-3">
                <label for="houseNumber" class="form-label">Hausnummer</label>
                <input type="text" id="houseNumber" formControlName="houseNumber" class="form-control"
                  placeholder="Hausnummer">
              </div>
              <div class="mb-3">
                <label for="postalCode" class="form-label">Postleitzahl</label>
                <input type="text" id="postalCode" formControlName="postalCode" class="form-control"
                  placeholder="Postleitzahl" maxlength="6">
              </div>
              <div class="mb-3">
                <label for="city" class="form-label">Ort</label>
                <input type="text" id="city" formControlName="city" class="form-control" placeholder="Ort">
              </div>
              <div class="mb-3">
                <label for="country" class="form-label">Land</label>
                <input type="text" id="country" formControlName="country" class="form-control" placeholder="Land">
              </div>
              <div class=" mb-3">
                <label for="coordinates" class="form-label">Geo-Koordinaten (automatisch generiert)</label>
                <div class="col-12">
                  <div class="input-group">
                    <span class="input-group-text" style="width:115px;">Lat:</span>
                    <input type="text" id="coordinates_lat" class="form-control" readonly>
                  </div>
                </div>
                <div class="col-12">
                  <div class="input-group">
                    <span class="input-group-text" style="width:115px;">Lon:</span>
                    <input type="text" id="coordinates_lon" class="form-control" readonly>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-primary mt-3 mb-3" (click)="generateCoordinates()">Koordinaten
                berechnen</button>
            </div>
          </div>
        </div>
        <div *ngIf="showStep3">
          <div class="row">
            <div class="d-none d-lg-inline col-lg-4">
              <div class="border-1 rounded-1 p-2 shadow-sm mb-2">
                <h5>Schritt 1</h5>
                <h6>Erstellen von GUID und Passwort</h6>
              </div>
              <div class="border-1 rounded-1 p-2 shadow-sm mb-2">
                <h5>Schritt 2</h5>
                <h6>Standortdaten eingeben</h6>
              </div>
              <div class="border-2 bg-light rounded-1 p-2 shadow-sm">
                <h5>Schritt 3</h5>
                <h6>Zusammenfassung</h6>
              </div>
            </div>
            <div class="col-12 col-lg-8">
              <p><strong>GUID:</strong> <span id="summaryGuid">{{guid}}</span></p>
              <p><strong>Passwort:</strong> <span id="summaryPassword">{{password}}</span></p>
              <p><strong>WSS-URL:</strong>{{wssurl}}</p>
              <p><strong>Hersteller (ChargePointVendor):</strong> <span id="chargePointVendor"></span></p>
              <p><strong>Modell (ChargePointModel):</strong> <span id="chargePointModel"></span></p>
              <p><strong>Verbindungs-Typ (LAN, WLAN, 4G/5G):</strong> <span id="imsi"></span></p>
              <p><strong>Seriennummer:</strong> <span id="serialNumber"></span></p>
              <p><strong>Meter Typ:</strong> <span id="meterType"></span></p>
              <p><strong>Meter Seriennummer:</strong> <span id="meterSerialNumber"></span></p>
              <p><strong>Anzahl der Ladepunkte:</strong> <span id="chargingPoints"></span></p>
              <p><strong>Ist ein MID-Zähler vorhanden?</strong> <span id="midMeter"></span></p>
              <p><strong>Maximale Ladeleistung:</strong> <span id="maxChargingPower"></span></p>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="backToPreviousStep()" *ngIf="!showStep1">Zurück</button>
      <button class="btn btn-primary" [disabled]="nextBtnDisabled" (click)="moveToNextStep()">Weiter</button>
    </div>
  </div>